import React, { useEffect, useState } from "react";
import { ConfigContext } from "./context/ConfigContext";

export const ConfigProvider = ({ children }) => {
  const [windowInFocus, setWindowInFocus] = useState(true);

  useEffect(() => {
    window.addEventListener("focus", () => setWindowInFocus(true));

    window.addEventListener("blur", () => setWindowInFocus(false));
  }, []);

  return (
    <ConfigContext.Provider value={{ windowInFocus }}>
      {children}
    </ConfigContext.Provider>
  );
};
